import React, { useState } from 'react';
import Card from '../../components/Card/Card';
import CardHeader from '../../components/Card/CardHeader';
import Container from '@material-ui/core/Container';
import styled from 'styled-components';
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import LockIcon from '@material-ui/icons/Lock';
import { FormattedMessage, useIntl } from 'react-intl';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import CardBody from '../../components/Card/CardBody';
import { useDispatch, useSelector } from 'react-redux';
import { login } from '../../store/actions/login';
import { ERROR, LOADING } from '../../enums/states';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { Redirect } from 'react-router';

const Page = styled.div`
  margin: 0;
  padding: 0;
  min-height: 100%;
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.7)), url('./background.jpg');
  background-size: cover;
  overflow: auto;
  border-radius: 3px;
`;

const HeaderWrapper = styled.div`
  text-align: center;
  padding: 1px;
`;

const LoginButton = styled.div`
  text-align: center;
  padding: 1px;
`;

const LoginFieldRow = styled.div`
  padding-bottom: 20px;
`;

const Alert = styled.div`
  text-align: center;
  background-color: red;
  color: white;
  padding: 20px 35px;
  border-radius: 3px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
`;

const getErrorCodeMessage = (code, intl) => {
  switch (code) {
    case 'INVALID_CREDENTIALS':
      return intl.formatMessage({ id: 'error.invalidCredentials' });
    default:
      return intl.formatMessage({ id: 'error.unknownError' });
  }
};

const LoginPage = () => {
  //petr@petrzatloukal.cz
  //abcdefgA1
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const intl = useIntl();
  const dispatch = useDispatch();

  const loginState = useSelector((state) => state.login);

  const loginFunction = (e) => {
    e.preventDefault();
    dispatch(login(userName, password));
  };

  const handleNameChange = (event) => {
    setUserName(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  return (
    <>
      {!!loginState.data && <Redirect to={'/'} />}
      <Page>
        <Container component="main" maxWidth="md">
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
            <Card>
              <CardHeader>
                <HeaderWrapper>
                  <h3>
                    <FormattedMessage id={'login.label'} />
                  </h3>
                </HeaderWrapper>
              </CardHeader>
              <CardBody style={{ padding: '0px 20px', paddingBottom: '20px', minWidth: '300px' }}>
                <form noValidate autoComplete="off">
                  <div style={{ paddingBottom: '40px' }}>
                    <LoginFieldRow>
                      <TextField
                        label={intl.formatMessage({ id: 'login.username' })}
                        value={userName}
                        onChange={handleNameChange}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <AccountCircleIcon />
                            </InputAdornment>
                          ),
                        }}
                        fullWidth
                      />
                    </LoginFieldRow>
                    <LoginFieldRow>
                      <TextField
                        label={intl.formatMessage({ id: 'login.password' })}
                        fullWidth
                        value={password}
                        onChange={handlePasswordChange}
                        type="password"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <LockIcon />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </LoginFieldRow>
                    {loginState.state === ERROR ? (
                      <Alert>
                        <ErrorOutlineIcon />
                        &nbsp;<span>{getErrorCodeMessage(loginState.error, intl)}</span>
                      </Alert>
                    ) : null}
                  </div>
                  <LoginButton>
                    <Button type="submit" color="primary" fullWidth onClick={loginFunction}>
                      {loginState.state === LOADING ? <CircularProgress size={24} /> : <FormattedMessage id={'login.button.label'} />}
                    </Button>
                  </LoginButton>
                </form>
              </CardBody>
            </Card>
          </Box>
        </Container>
      </Page>
    </>
  );
};

export default LoginPage;
